import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Seo } from "@/components/Seo";
import { formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back.");
      nav("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const field = "bg-transparent border-0 border-b border-white/20 rounded-none px-0 h-12 text-bone placeholder:text-muted2/60 focus-visible:ring-0 focus-visible:border-gold text-base";

  return (
    <div data-testid="login-page" className="min-h-screen flex items-center justify-center px-6 bg-ink">
      <Seo title="Advisor Login" path="/login" noindex />
      <div className="w-full max-w-sm">
        <Link to="/" className="block text-center mb-12">
          <span className="font-serif text-2xl">Irina Ishik</span>
          <span className="block font-mono text-[9px] tracking-[0.3em] text-gold uppercase mt-1">Advisor Access</span>
        </Link>
        <form onSubmit={submit} data-testid="login-form" className="space-y-8">
          <Input data-testid="login-email" type="email" className={field} placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <Input data-testid="login-password" type="password" className={field} placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="w-full font-sans text-xs uppercase tracking-[0.2em] bg-gold text-ink py-4 hover:bg-goldhover transition-colors disabled:opacity-50">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
